import { useMemo } from 'react';
import { isNativeEmbed } from '../../../app/nativeAuthTokenHandoff';

/**
 * Whether the page is drawn inside a native app's WebView (the `Music24Native/…` user agent).
 *
 * Design §4: such a page draws no navigation of its own — no sidebar, no bars, no artist switcher,
 * no account sheet. The native app owns back, the title and the tabs. The user agent does not
 * change while the page lives, so it is read once.
 */
export function useIsNativeEmbed(): boolean {
  return useMemo(() => typeof navigator !== 'undefined' && isNativeEmbed(navigator.userAgent), []);
}
